import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import Grid from "@mui/material/Grid";
import { MultiDocumentRow } from "../MultiDocumentRow/MultiDocumentRow";
import { RO_DOCUMENTS } from "../../../../constants";
import { findAgendDocument } from "../../../../utils/documents";
import { getRoDocuments } from "../../../../store/selectors/appConfig";

/**
 * RoDocument component renders a row of RO documents for a stakeholder.
 *
 * @component
 * @param {Object} props
 * @param {string} props.uniqueId - Unique identifier for the document.
 * @param {string} [props.downloadUrl] - URL for downloading the document.
 * @param {string} [props.downloadLabel] - Label for the download button.
 * @param {string|number} [props.stakeholderIndex] - Index of the stakeholder.
 * @returns {JSX.Element}
 */
export const RoDocument = ({
  uniqueId,
  downloadUrl = "",
  downloadLabel = "",
  stakeholderIndex = ""
}) => {
  const documents = useSelector(getRoDocuments);
  const { documents: document } = findAgendDocument(documents, uniqueId, stakeholderIndex);
  return (
    <Grid container>
      <Grid item xs={12}>
        {!isEmpty(document) && (
          <MultiDocumentRow
            document={document}
            type={RO_DOCUMENTS}
            downloadUrl={downloadUrl}
            downloadLabel={downloadLabel}
            stakeholderIndex={stakeholderIndex}
          />
        )}
      </Grid>
    </Grid>
  );
};

RoDocument.propTypes = {
  /** Unique identifier for the document */
  uniqueId: PropTypes.string.isRequired,
  /** URL for downloading the document */
  downloadUrl: PropTypes.string,
  /** Label for the download button */
  downloadLabel: PropTypes.string,
  /** Index of the stakeholder */
  stakeholderIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
